// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

import './Nav.css';
;

function Nav(Props) {
  return React.createElement("div", {
              className: "nav"
            }, React.createElement("a", {
                  className: "brand",
                  href: "/"
                }, React.createElement("img", {
                      className: "logo",
                      src: "https://rescript-lang.org/static/nav-logo-full@2x.png"
                    }), React.createElement("div", undefined, " React HackerNews")));
}

var make = Nav;

export {
  make ,
  
}
/*  Not a pure module */
